export default class ApprovedElement {
    data;
    digest;
    digestMethod;
    constructor(approvedElement = {}) {
        Object.assign(this, approvedElement);
    }
}
//# sourceMappingURL=ApprovedElement.js.map